import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/Digital.css';

const Digital = () => {
  // Gallery images
  const galleryImages = [
    '/assets/img/digital_ads_portfolio/digital-portfolio.jpg',
    '/assets/img/digital_ads_portfolio/digital-portfolio2.webp',
    '/assets/img/digital_ads_portfolio/digital-portfolio3.webp',
    '/assets/img/digital_ads_portfolio/digital-portfolio4.jpg'
  ];

  // Platform data
  const platforms = [
    { name: 'Instagram', logo: '/assets/img/digital_advertisement/inst-ads.webp' },
    { name: 'Facebook', logo: '/assets/img/digital_advertisement/facebook-ads.png' },
    { name: 'WhatsApp', logo: '/assets/img/digital_advertisement/whatsapp-ads.webp' },
    { name: 'YouTube', logo: '/assets/img/digital_advertisement/youtube-ads.jpg' },
    { name: 'Google Ads', logo: '/assets/img/digital_advertisement/google-ads.png' }
  ];

  // Services data
  const services = [
    {
      title: 'Internet Marketing Services',
      description: 'ROI-driven digital strategies to grow your business online through SEO, email, and analytics.',
      features: [
        'SEO Services: Boost your visibility with on-page, off-page, and local SEO.',
        'Conversion Rate Optimization: Turn more visitors into leads and customers.',
        'Email Marketing: Drive repeat engagement with automated campaigns.',
        'Website Analytics: Track what works with GA4, heatmaps, and user flows.',
        'Website Audits: Identify technical issues holding back performance.'
      ]
    },
    {
      title: 'Advertising Agency Services',
      description: 'Reach the right audience at the right time with high-performance ad campaigns.',
      features: [
        'Google Ads: Get found instantly with search and display ad campaigns.',
        'Display Ads: Run banner ads across high-traffic networks.',
        'Video Ads: Capture attention with YouTube and short-form ad content.',
        'LinkedIn Ads: Target decision-makers in B2B verticals.',
        'Shopping Ads: Promote products on Google for direct purchase intent.'
      ]
    },
    {
      title: 'Marketing Agency Services',
      description: 'Full-service digital marketing from one strategic partner, combining strategy, content, and automation to scale visibility and ROI.',
      features: [
        'End-to-End Campaign Management: Execute and manage complete digital campaigns across SEO, paid media, social, and email - from start to finish.',
        'Social Media Marketing (Organic + Paid): Grow brand presence through engaging content, paid ads, and platform-specific strategies.',
        'Content Marketing & Automation: Deliver SEO-rich, high-converting content at scale using automation tools like HubSpot, Mailchimp, and AI.',
        'AI-Powered SEO Content: Leverage automation and generative AI to publish content optimized for search engines and generative answers.',
        'B2B & Local Lead Generation: Generate qualified leads using LinkedIn, Google and local search strategies.'
      ]
    }
  ];



  // Video autoplay effect
  useEffect(() => {
    const video = document.querySelector('.background-video');
    if (video) {
      video.play().catch(function(error) {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <div className="digital-page">
      {/* Hero Section with Video */}
      <section className="digital-hero-section">
        {/* Background Video */}
        <video className="digital-background-video" autoPlay muted loop playsInline>
          <source src="/assets/hero section videos/hero sections 3.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark Overlay */}
        <div className="digital-overlay"></div>

        {/* Main Content */}
        <main className="digital-main-content">
          <div className="digital-hero-content">
            <h1 className="digital-hero-text">Digital Advertising Agency</h1>
            <p className="digital-hero-subtitle">
              Transform your brand's digital presence with cutting-edge marketing strategies
            </p>
            <div className="digital-hero-buttons">
              <button className="digital-hero-btn primary" onClick={() => window.location.href = '/reachus'}>
                Get Started
              </button>
              <button className="digital-hero-btn secondary" onClick={() => document.querySelector('.digital-services-section').scrollIntoView({ behavior: 'smooth' })}>
                Our Services
              </button>
            </div>
          </div>
          <div className="digital-scroll-indicator">
            <div className="digital-scroll-arrow"></div>
          </div>
        </main>
      </section>

      {/* Digital Advertising Section */}
      <section className="digital-advertising">
        <h2 className="digital-section-heading">Digital Advertisement</h2>
        <p className="digital-section-description">
          Boost your brand visibility with our powerful Digital Marketing strategies! From engaging stories on Instagram and direct outreach via WhatsApp, to impactful video promotions on YouTube, targeted Google Ads, and wide-reaching Facebook campaigns we help you connect with your audience where they are most active. Let your brand stand out and drive real results.
        </p>
        <div className="digital-platforms-grid">
          {platforms.map((platform, index) => (
            <div key={platform.name} className="digital-platform-card">
              <img src={platform.logo} alt={platform.name} className="digital-platform-logo" />
              <h3 className="digital-platform-name">{platform.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="digital-services-section">
        <h2 className="digital-services-main-heading">Our Core Digital Marketing Services</h2>
        <div className="digital-services-container">
          {services.map((service, index) => (
            <div key={index} className="digital-service-column">
              <h3 className="digital-service-heading">{service.title}</h3>
              <p className="digital-service-description">{service.description}</p>
              <ul className="digital-service-list">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <span className="digital-checkmark">&#10003;</span> <strong>{feature.split(':')[0]}:</strong> {feature.split(':')[1]}
                  </li>
                ))}
              </ul>
              <a href="/contact" className="digital-explore-link">Contact Us →</a>
            </div>
          ))}
        </div>
      </section>

      {/* Our Works Section */}
      <section className="digital-our-works-section">
        <h2 className="digital-works-heading">Our Works on Digital Advertisement</h2>
        <div className="digital-works-container">
          <div className="digital-phone-display">
            <div className="digital-phone-frame">
              <img src="/assets/img/our_work_on_digital/google.png" alt="Truecaller Advertising Display" className="digital-phone-screen" />
            </div>
          </div>
          <div className="digital-works-content">
            <h3 className="digital-works-subheading">GOOGLE ADS</h3>
            <p className="digital-works-description">
              Google Ads helps you reach people actively searching for products or services like yours. By targeting the right keywords, locations, and audience interests, your ads appear on top of Google Search, YouTube, and partner websites.
            </p>
            <p className="digital-works-description">
              This brings high-quality traffic to your website, increases brand visibility, and boosts leads and sales all while staying within your budget. With detailed analytics, you can measure and improve performance continuously.
            </p>
            <button className="digital-know-more-btn">KNOW MORE</button>
          </div>
        </div>
      </section>

      {/* Instagram Advertising Section */}
      <section className="digital-instagram-section">
        <div className="digital-instagram-container">
          <div className="digital-instagram-content">
            <h3 className="digital-instagram-subheading">INSTAGRAM ADS</h3>
            <p className="digital-instagram-description">
              Instagram is one of the most powerful platforms to visually engage with your audience. With features like reels, stories, carousels, and ads, businesses can showcase products creatively, build trust, and connect emotionally with customers.
            </p>
            <p className="digital-instagram-description">
              Targeted advertising allows you to reach the right people based on age, interest, location, and behavior. Instagram's shopping tools and influencer collaborations further drive brand awareness and conversions.
            </p>
            <p className="digital-instagram-description">
              Whether you're a small business or a large brand, Instagram helps you stay relevant, increase visibility, and convert followers into loyal customers.
            </p>
            <button className="digital-instagram-btn">KNOW MORE</button>
          </div>
          <div className="digital-instagram-phone-display">
            <div className="digital-instagram-phone-frame">
              <img src="/assets/img/our_work_on_digital/inst.png" alt="Instagram Advertising Display" className="digital-instagram-phone-screen" />
            </div>
          </div>
        </div>
      </section>

      {/* YouTube Advertising Section */}
      <section className="digital-youtube-section">
        <div className="digital-youtube-container">
          <div className="digital-youtube-phone-display">
            <div className="digital-youtube-phone-frame">
              <img src="/assets/img/our_work_on_digital/YouTube.jpg" alt="YouTube Advertising Display" className="digital-youtube-phone-screen" />
            </div>
          </div>
          <div className="digital-youtube-content">
            <h3 className="digital-youtube-subheading">YOUTUBE ADS</h3>
            <p className="digital-youtube-description">
              YouTube is a dynamic platform to educate, entertain, and influence your audience through video. With over 2 billion users, it helps businesses build trust, demonstrate products, and tell compelling brand stories.
            </p>
            <p className="digital-youtube-description">
              YouTube ads and SEO-optimized content increase visibility, drive website traffic, and boost customer engagement. Whether it's tutorials, testimonials, or behind-the-scenes content, YouTube builds strong brand recall and converts viewers into loyal customers.
            </p>
            <button className="digital-youtube-btn">KNOW MORE</button>
          </div>
        </div>
      </section>

      {/* WhatsApp Advertising Section */}
      <section className="digital-whatsapp-section">
        <div className="digital-whatsapp-container">
          <div className="digital-whatsapp-content">
            <h3 className="digital-whatsapp-subheading">WHATSAPP ADS</h3>
            <p className="digital-whatsapp-description">
              Growing your business today requires more than just a great product it demands strong digital visibility and emotional brand connection. At ARK Moving Images, we help brands create a powerful presence across platforms.
            </p>
            <p className="digital-whatsapp-description">
              Start by building a professional website, optimizing it with SEO, and staying active on social platforms like Instagram, Facebook, and LinkedIn. Digital marketing plays a key role with Google Ads placing your brand on top of search results, YouTube delivering visual stories to massive audiences, and Instagram, Facebook, and WhatsApp helping you connect directly through reels, ads, and updates.
            </p>
            <p className="digital-whatsapp-description">
              Creating impactful content like customer testimonials, behind-the-scenes glimpses, and brand stories builds credibility and trust.
            </p>
            <button className="digital-whatsapp-btn">KNOW MORE</button>
          </div>
          <div className="digital-whatsapp-phone-display">
            <div className="digital-whatsapp-phone-frame">
              <img src="/assets/img/our_work_on_digital/whatapp.jpg" alt="WhatsApp Advertising Display" className="digital-whatsapp-phone-screen" />
            </div>
          </div>
        </div>
      </section>

      {/* Facebook Advertising Section */}
      <section className="digital-facebook-section">
        <div className="digital-facebook-container">
          <div className="digital-facebook-phone-display">
            <div className="digital-facebook-phone-frame">
              <img src="/assets/img/our_work_on_digital/facebook.webp" alt="Facebook Advertising Display" className="digital-facebook-phone-screen" />
            </div>
          </div>
          <div className="digital-facebook-content">
            <h3 className="digital-facebook-subheading">FACEBOOK ADVERTISING</h3>
            <p className="digital-facebook-description">
              Facebook Advertising is a powerful tool to grow your business by reaching the right audience with targeted precision. With over 2.9 billion monthly active users, Facebook allows you to promote your brand, products, or services to people based on age, location, interests, behavior, and more.
            </p>
            <p className="digital-facebook-description">
              You can run ads in various formats in image, video, carousel, or story and track real-time performance through Facebook Ads Manager. Whether you're aiming to drive website traffic, increase page engagement, generate leads, or boost sales, Facebook Ads deliver measurable results at a relatively low cost.
            </p>
            <p className="digital-facebook-description">
              With ARK Moving Images, you can create emotionally engaging visual ads that capture attention, build trust, and turn views into loyal customers.
            </p>
            <button className="digital-facebook-btn">KNOW MORE</button>
          </div>
        </div>
      </section>

      {/* Portfolio Gallery Section */}
      <section className="digital-gallery-section">
        <h2 className="digital-gallery-heading">Our Digital Advertising Portfolio</h2>
        <div className="digital-gallery-container">
          <div className="digital-gallery-grid">
            {galleryImages.map((image, index) => (
              <div key={index} className="digital-gallery-item">
                <img src={image} alt={`Digital Advertising ${index + 1}`} className="digital-gallery-image" />
              </div>
            ))}
          </div>
        </div>
      </section>


      <Footer />
    </div>
  );
};

export default Digital;

